module.exports = __webpack_public_path__ + "static/media/intro-iphone.8ef0ff66.png";